{
  "version": 1,
  "asset_id": "972c437e-8fda-41af-81d2-2a32ba686ca2",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/972c437e-8fda-41af-81d2-2a32ba686ca2/hero-music-on.mp4",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/972c437e-8fda-41af-81d2-2a32ba686ca2/hero-music-on.mp4",
  "original_filename": "hero-music-on.mp4",
  "size": 522848,
  "content_type": "video/mp4",
  "created_at": "2026-11-04T13:09:21Z"
}
